__turbopack_context__.v({
  "buttonsWrapper": "editor-buttons-group-module__dbVFLW__buttonsWrapper",
  "darkTheme": "editor-buttons-group-module__dbVFLW__darkTheme",
  "divider": "editor-buttons-group-module__dbVFLW__divider",
  "editorButtonsWrapper": "editor-buttons-group-module__dbVFLW__editorButtonsWrapper",
  "minimapCheckboxWrapper": "editor-buttons-group-module__dbVFLW__minimapCheckboxWrapper",
  "minimapLabel": "editor-buttons-group-module__dbVFLW__minimapLabel",
  "undoRedoButtonsWrapper": "editor-buttons-group-module__dbVFLW__undoRedoButtonsWrapper",
});
